import Glide from "@glidejs/glide";
import { useEffect, useId, useRef } from "react";
import CardCategory3, {
  CardCategory3Props,
} from "./CardCategories/CardCategory3";
import Heading from "./Heading/Heading";

export const CATS_DISCOVER: CardCategory3Props[] = [];

interface bannerPorpos {
  data: CardCategory3Props[];
}

const sliderConfiguration: any = {
  type: "carousel",
  autoplay: 2000,
  perView: 3,
  gap: 22,
  bound: true,
  focusAt: "center",
  breakpoints: {
    1280: {
      gap: 28,
      perView: 2.5,
    },
    1279: {
      gap: 20,
      perView: 2.15,
    },
    1023: {
      gap: 20,
      perView: 1.6,
    },
    768: {
      gap: 20,
      perView: 1.2,
    },
    500: {
      gap: 20,
      perView: 1,
    },
  },
};
const DiscoverMoreSlider = ({ data }: bannerPorpos) => {
  const id = useId();
  const UNIQUE_CLASS = "glidejs" + id.replace(/:/g, "_");

  const sliderRef = useRef(null);

  const slider = new Glide(`.${UNIQUE_CLASS}`, sliderConfiguration);

  useEffect(() => {
    if (data.length > 0) slider.mount();
    return () => {
      slider.destroy();
    };
  }, [slider]);
  return (
    <div
      id={UNIQUE_CLASS}
      className={` nc-DiscoverMoreSlider nc-p-l-container ${UNIQUE_CLASS} `}
      ref={sliderRef}
    >
      <Heading
        className="mb-12 lg:mb-14 text-neutral-900 dark:text-neutral-50 nc-p-r-container "
        desc=""
        rightDescText=""
        hasNextPrev
      >
        Découvrez nos partenaires
      </Heading>
      <div className="" data-glide-el="track">
        <ul className="glide__slides">
          {data.map((item, index) => (
            <li key={index} className={`glide__slide`}>
              <CardCategory3
                heading={item.subHeading}
                desc={item.heading}
                image={`api/media/partner/${item.image}`}
                color={item.color}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DiscoverMoreSlider;
